import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { SearchServiceModel } from './model';
import { SearchServiceState } from './state';
import * as selectors from './selectors';
import * as actions from './actions';

@Injectable()
export class SearchServiceFacade {
  private store = inject<Store<SearchServiceState>>(Store);

  public entities$ = this.store.pipe(select(selectors.selectAll));

  public search(searchString: string) {
    this.store.dispatch(new actions.SearchRequestAction(searchString));
  }

  public getSelected(): Observable<SearchServiceModel> {
    return this.store.pipe(select(selectors.selectSelected));
  }

  public setSelected(model: SearchServiceModel) {
    this.store.dispatch(new actions.SetSelectedRequestAction(model));
  }

  public getError(): Observable<any> {
    return this.store.pipe(select(selectors.selectError));
  }

  public isLoading(): Observable<boolean> {
    return this.store.pipe(select(selectors.selectIsLoading));
  }
}
